import React, { Component } from 'react';
import Banner from '../../components/Banner';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DynamicPage from '../../components/DynamicPage';
import { URL } from '../../components/BackendApi';

class CoursePaymentAcceptPage extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: true, error: null, dynamicData: null };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    const sessionId = params.get('id');

    // Update payment status
    if (sessionId) {
      fetch(`${URL}/courses/public/payment/accept?id=${sessionId}`)
        .catch(() => {});
    }

    // Try to load dynamic page content
    fetch(`${URL}/pages/content_blocks?url=${encodeURIComponent('/koulutus/maksu/onnistui')}`)
      .then(response => {
        if (!response.ok) throw new Error('No dynamic content');
        return response.json();
      })
      .then(data => {
        if (data.content_blocks && data.content_blocks.length > 0) {
          this.setState({ dynamicData: data, loading: false });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    if (this.state.loading) {
      return (
        <div className="page">
          <Banner><h1>Maksu onnistui</h1></Banner>
          <Container className="p-t-50 p-b-50 text-center">
            <p>K&auml;sitell&auml;&auml;n maksua...</p>
          </Container>
        </div>
      );
    }

    if (this.state.dynamicData) {
      return <DynamicPage data={this.state.dynamicData} />;
    }

    return (
      <div className="page">
        <Banner><h1>Maksu onnistui</h1></Banner>
        <Container className="p-t-50 p-b-50 text-center">
          <Row>
            <Col md={{ span: 8, offset: 2 }}>
              <h2>Kiitos ilmoittautumisesta!</h2>
              <p>Maksusi on vastaanotettu ja paikkasi on vahvistettu.</p>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default CoursePaymentAcceptPage;
